import { render, staticRenderFns } from "./help-tip.vue?vue&type=template&id=552f7c04"
var script = {}
import style0 from "./help-tip.vue?vue&type=style&index=0&id=552f7c04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports